<template>
<div class="results">
<v-card class="box">
            <v-card-text>
                <v-layout row wrap align-center>
                    <v-flex xs12 class="pa-0">
                        <div class="headline mb-3">Results </div> 
                    </v-flex>
                    <v-flex xs6 class="subheading">Indicative Interest Rate</v-flex>
                    <v-flex xs6 class="subheading"><strong>{{interestRate }} % p.a.</strong></v-flex>
                    <v-flex xs6 class="subheading">Comparison Rate</v-flex>
                    <v-flex xs6 class="subheading primary--text"> <div v-if="Number(loan.amount) >= $minLoan"><strong>{{comparisonRate }} % p.a.</strong></div></v-flex>
                    <v-flex xs6 class="subheading"> Weekly Repayment</v-flex>
                    <v-flex xs6 class="subheading primary--text"> <div v-if="Number(loan.amount) >= $minLoan"><strong>${{weeklyPayment}}</strong></div></v-flex>
                    <v-flex xs6 class="subheading"> Balloon Payment</v-flex>
                    <v-flex xs6 class="subheading primary--text">
                        <div v-if="showBalloon">
                         <strong>${{balloonPayment}}</strong>
                        </div>
                        <div v-else> Not Available</div>
                    </v-flex>
                    <v-flex xs6 class="subheading " v-if="showBalloon" style="margin-top:-10px">Balloon Percentage</v-flex>
                    <v-flex xs6 class="subheading primary--text" v-if="showBalloon" >
                        <v-select height="15"
                                :items="selectBalloon"
                                v-model='balloonPercentage'
                                suffix="%"
                                no-data-text="Not available"
                                dark></v-select>
                    </v-flex>
                    <v-flex xs6 >
                        <v-btn block depressed small color="primary" @click="showEnquiry()"> Enquire Now</v-btn>
                    </v-flex>
                    <v-flex xs6>
                        <v-btn block depressed small color="primary" @click="showEmail()"> Email me quote</v-btn>
                    </v-flex>
                    <v-flex xs12 style="margin-top:-10px !important">
                        <v-btn block depressed small color="primary" @click="apply()">Apply Now</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import excelFunc from '@/excelFunctions.js';
export default {
  name: 'Results',
  props:  {
      businessVars:Object, //input object that contains all the business rate variables. 
      privateVars: Object, // input object that contains all the  private rates variables taken from google sheets. 
      loan: Object, //input object  contains all the loan data required to calculate interest rate/comparison rate etc.
      value: Object //output object contains all the result calculations, interest rate etc. 
  },
  data() {
    return {
        balloonPercentage:this.calculateBalloonDefault(this.loan.term),
        outputObj:{interestRate:0, comparisonRate:0, weeklyPayment:0, balloonPayment:0}
    }
  },
  mounted() {
    //send through initial values.
    //console.log("sending through initial values");
    this.$emit('input',this.output());
  },
  methods: {
        showEnquiry() {this.$emit('enquiry')},
        showEmail() {this.$emit('email')},
        apply() {this.$emit('apply')},
        output: function(){
            this.outputObj.interestRate=this.interestRate;
            this.outputObj.comparisonRate= this.comparisonRate;
            this.outputObj.weeklyPayment= this.weeklyPayment;
            this.outputObj.balloonPayment= this.balloonPayment;
            //console.log("changed output"+this.interestRate);
            return this.outputObj
        },
        calculateBalloonDefault: function(val){
            return 0;
            var values = [0, 10, 20, 30, 40, 50, 60];
            if (val > 60){ return 0;} //no balloon payment for values above 60 months. 
            switch (Math.floor(val/ 12)) {
                case 0:
                case 1:
                case 2:
                return values[6];
                break;
                case 3:
                return values[5];
                break;
                case 4:
                return values[4];
                break;
                case 5:
                return values[3];
                break;
                default:
                return 0;
            }
        },
    },

    computed: {
        rateVars: function() {
            return this.loan.carUse == this.$buttonValues.BUSINESS ? this.businessVars : this.privateVars
        },
        balloonPayment() {                
            return (Number(this.loan.amount) * this.balloonPercentage /100);
        },
        interestRate: function() {
            var def=0;
            def=this.rateVars.baseRate + this.rateVars.margin;
            if (this.loan.creditRating === this.$buttonValues.AVERAGE) { //1 means average
                def += this.rateVars.creditRating;
            }
            if (Number(this.loan.amount) < 10000){
                def += this.rateVars.lessThan10k;
            }
            if (this.loan.term > 60 ){
                def += this.rateVars.longerThan5Years;
            }

            if (this.loan.carType === this.$buttonValues.USED){
                def += this.rateVars.carType;
            }
            /*if (this.loan.carUse === this.$buttonValues.BUSINESS){
                def += this.rateVars.carUse;
            } REMOVED IN V2*/
            if (this.loan.residency === this.$buttonValues.RENTING){
                def += this.rateVars.residency;
            }

            return def.toFixed(2);
        },
        monthlyPayment: function() {
            // var pmt = (this.loanAmount * rate * Math.pow((1 + rate), this.loanTerm)) / (1 - Math.pow((1 + rate), this.loanTerm * -1)); does not work
            //console.log(this.interestRate/1200,this.loanTerm, -1*this.loanAmount, this.balloonPayment)

            //loan total is loan amount + financier fees + dealer fees.
            //monthly payment is the calculated monthly payment from PMT function plus the monthly fee.
            //interest rate needs to be monthly /12 & also a percentage /100 as loan term is in months.
            let total = -1*(this.rateVars.financierFees+this.rateVars.dealerFees + Number(this.loan.amount));
            let result=excelFunc.pmt(this.interestRate/1200,this.loan.term,total , this.balloonPayment) + this.rateVars.monthlyFee;
            return result;
        },
        weeklyPayment: function() {
        return  (this.monthlyPayment*12/52).toFixed(2);},

        comparisonRate: function() {

            let x=30000;
            let initial=x+this.rateVars.financierFees+ this.rateVars.dealerFees;
            let term=60;
            let monthlyPayment=excelFunc.pmt(this.interestRate/1200, term, -1*initial, 0) + this.rateVars.monthlyFee
            
            let result= excelFunc.rate(term, monthlyPayment, -1 * x, 0)*12*100;
            return result.toFixed(2);
        },
        showBalloon() {
            return this.selectBalloon.length > 0 //&& this.loan.carUse === this.$buttonValues.BUSINESS; //not for private use and there are select items to display
        },
        selectBalloon() {
            var values=[0,10,20,30,40,50,60];
            if (this.loan.term < 24 || this.loan.term > 60) {return [];} //should not exist for terms longer than 60 months or less than 24 months

            switch(Math.floor(this.loan.term/12)){
                case 0: return []; break;
                case 1: return []; break;
                case 2: return values; break;
                case 3: return values.splice(0,6); break;
                case 4: return values.splice(0,5); break;
                case 5: return values.splice(0,4); break;
                default: return [];

            }
        }

    },
    //needed to trigger calculateBallonDefault to update
    watch: {
        //watchers on all computed properties that will be outputed.
        comparisonRate: function(val) {
            this.outputObj.comparisonRate= val
            this.$emit('input',this.output());
        },
        interestRate: function(val) {
            this.outputObj.interestRate= val
            this.$emit('input',this.output());
        },
        weeklyPayment: function(val) {
            this.outputObj.weeklyPayment= val
            this.$emit('input',this.output());
        },
        balloonPayment: function(val) {
            this.outputObj.balloonPayment= val
            this.$emit('input',this.output());
        },
        "loan.term": function(val) {
        this.balloonPercentage=this.calculateBalloonDefault(val);
        } //this needs to be watched instead of computed as there is no var in the html to trigger the computation
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
